// NOTE: populated by plugins, etc
const initialState = {
	GA: {}
};
export default initialState; 


// WEBPACK FOOTER //
// ./D:/Repos/university/my-composer/app/store/initialState.js